import { render, staticRenderFns } from "./Splashscreen.vue?vue&type=template&id=1f396f0f&"
import script from "./Splashscreen.vue?vue&type=script&lang=js&"
export * from "./Splashscreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports